export enum ActionType {
  GET_SHIPPING_SERVICE_DETAIL_REQUEST = `shipments/package-order/GET_SHIPPING_SERVICE_DETAIL_REQUEST`,
  GET_SHIPPING_SERVICE_DETAIL_REQUEST_SUCCESS = `shipments/package-order/GET_SHIPPING_SERVICE_DETAIL_REQUEST_SUCCESS`,
  GET_SHIPPING_SERVICE_DETAIL_REQUEST_FAILURE = `shipments/package-order/GET_SHIPPING_SERVICE_DETAIL_REQUEST_FAILURE`,

  CLEAR_MESSAGE_ERROR = `shipments/packages/CLEAR_MESSAGE_ERROR`,
  CLEAR_SHIPPING_SERVICE_DETAIL_REQUEST_STATE = `shipments/packages/CLEAR_SHIPPING_SERVICE_DETAIL_REQUEST_STATE`,
}

export type Action = any;
//   | FSA<ActionType.TOKEN_REQUEST>
